import { Weekly, WeeklyListView, Monthly, MonthlyListView, Yearly, YearlyListView } from "./Templates";


export default function Every(props) {
    const { frequency } = props;
    const previewFormat = () => {
        switch (frequency) {
            case "WEEKLY": return <Weekly {...props} />;
            case "MONTHLY": return <Monthly {...props} />;
            case "YEARLY": return <Yearly {...props} />;
            case "DAILY": return <></>;
            default: return <></>;
        }
    }

    return previewFormat()
}


export const EveryList = (props) => {
    const { data } = props;
    const previewFormat = () => {
        switch (data?.scheduleFrequency?.repeatType) {
            case "WEEKLY": return <WeeklyListView {...props} />;
            case "MONTHLY": return <MonthlyListView {...props} />;
            case "YEARLY": return <YearlyListView {...props} />;
            case "DAILY": return <>---</>;
            default: return <>---</>;
        }
    }

    return previewFormat()
}